import React from "react";
import { Group, Text } from "@mantine/core";
import { Link } from "react-router-dom";

function RyncastIcon(props: React.ComponentPropsWithoutRef<"svg">) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="none"
    >
      <defs>
        <linearGradient id="rg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#9b59f5" />
          <stop offset="100%" stopColor="#6c3bde" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="10" fill="url(#rg)" />
      {/* Play triangle */}
      <polygon points="15,12 30,20 15,28" fill="white" opacity="0.95" />
      {/* Waveform bars on the left */}
      <rect x="8" y="17" width="3" height="6" rx="1.5" fill="white" opacity="0.7" />
      <rect x="5" y="14" width="2" height="12" rx="1" fill="white" opacity="0.4" />
    </svg>
  );
}

export function Logo(props: React.ComponentPropsWithoutRef<"div">) {
  return (
    <Link to="/dashboard" style={{ textDecoration: "none" }}>
      <Group gap={8} wrap="nowrap" {...(props as any)}>
        <RyncastIcon width={30} height={30} style={{ flexShrink: 0 }} />
        <Text
          fw={700}
          size="lg"
          style={{
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "-0.3px",
            background: "linear-gradient(135deg, #9b59f5 0%, #6c3bde 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Ryncast
        </Text>
      </Group>
    </Link>
  );
}
